import { type BlokProps, StoryblokComponentList } from "@trydig/storyblok";
import BlokWrap from "@/components/bloks/BlokWrap";
import { AccordionRoot } from "@/components/ui/Accordion";
import type { BlokAccordionGroupItem } from "@/storyblok";
import styles from "./AccordionGroupItemBlok.module.css";

export const AccordionGroupItemBlok = ({
	blok,
	preview,
	...rest
}: BlokProps<BlokAccordionGroupItem>) => {
	if (!blok.items) return null;

	return (
		<BlokWrap editable={blok} asChild>
			<AccordionRoot className={styles.root} {...rest}>
				<StoryblokComponentList bloks={blok.items} preview={preview} />
			</AccordionRoot>
		</BlokWrap>
	);
};
